// chartOption is GraphMain's isSelected array:
// [0] heater temp vs real time
// [1] heater temp vs time
// [2] energy / gas consumption
// [3] data consumption
//
// Only [1] and [2] have a finer interval to drill into. Real time buckets
// shift as new points arrive, and data consumption has nothing underneath it,
// so both get scale only — matching what the telemetry page already does.
export const showDetailControl = (isReadyToRender, chartOption) =>
  Boolean(isReadyToRender && (chartOption?.[1] || chartOption?.[2]));
